<template>
    <v-form v-model="valid" ref="form" lazy-validation>
        <v-container fluid>
            <div class="headline">{{__('labels.bank_account')}}</div>
            <v-layout row wrap>
                <v-flex xs12 md6>
                    <s-text-field
                            v-model="bankAccount.iban"
                            :label="__('labels.bank_account_iban')"
                            :rules="rules.iban"
                            mask="AANN NNNN NNNN NNNN NNNN NNNN NNNN NNNN NN"
                            return-masked-value
                    >
                    </s-text-field>
                </v-flex>
                <v-flex xs12 md6>
                    <s-text-field
                            v-model="bankAccount.swift"
                            :label="__('labels.bank_account_swift') + ' ' + __('labels.optional')"
                            :rules="rules.swift">
                    </s-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12>
                    <s-text-field
                            v-model="bankAccount.owner"
                            :label="__('labels.bank_account_owner') + ' ' + __('labels.optional')"
                            :hint="__('labels.bank_account_owner_hint')"
                            :rules="rules.owner">
                    </s-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex shrink>
                    <button-previous></button-previous>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex shrink>
                    <button-next @click="nextButtonClick()"></button-next>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
    import {mapState} from 'vuex'
    import {mapMutations} from 'vuex'
    import {mapActions} from 'vuex'
    var IBAN = require('iban');
    export default {
        name: "BankAccountStep",
        computed: {
            ...mapState('form',[
                'bankAccount',
            ]),
            iban: {
                get() {
                    return this.bankAccount.iban;
                },
                set(iban) {
                    // this.bankAccount.iban = iban;
                    // this.$nextTick(()=>{
                    //     this.bankAccount.iban = IBAN.printFormat(iban.replace(/ /g, '').substr(0, 34));
                    // });
                }
            }
        },
        data() {
            return {
                valid: false,
                rules: this.$validation.create({
                        owner: [],
                        iban: ['required', (value) => !value || IBAN.isValid(value) || this.__('errors.invalid_iban')],
                    }
                )
            }
        },
        methods: {
            ...mapMutations('stepper', [
                'nextStep'
            ]),
            ...mapActions('form', [
                'setError',
            ]),
            nextButtonClick() {
                if (this.$refs.form.validate()) {
                    this.$cookies.set('bankAccount', this.bankAccount);
                    this.nextStep();
                } else {
                    this.setError(this.__('messages.form_invalid'));
                }
            },
        },
    }
</script>

<style scoped>

</style>